import { render, staticRenderFns } from "./league-listing.vue?vue&type=template&id=b2a3ee38&"
import script from "./league-listing.vue?vue&type=script&lang=js&"
export * from "./league-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports